'use client';
import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';

const NAV_LINKS: { label: string; href: string }[] = [
  { label: 'Servicii', href: '#' },
  { label: 'FAQ', href: '#' },
  { label: 'Prețuri Flotă', href: '#' },
  { label: 'Confidențialitate', href: '/confidentialitate' },
  { label: 'Termeni', href: '/termeni' },
];

export default function Footer() {
  return (
    <footer
      className="border-t"
      style={{ borderColor: 'rgba(63,63,70,0.5)', padding: '48px 0 40px' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo + links */}
          <div className="flex items-center gap-8 flex-wrap justify-center md:justify-start">
            <div className="flex flex-col items-start">
              <AppImage
                src="/assets/images/logoasadetailing-1779127650999.png"
                alt="Asa Detailing logo"
                width={100}
                height={34}
                className="object-contain"
                style={{ maxHeight: '34px', width: 'auto' }}
              />
              <span
                style={{
                  fontSize: '10px',
                  color: 'var(--aluminum-dim)',
                  fontFamily: 'DM Sans, sans-serif',
                  letterSpacing: '0.04em',
                  marginTop: '2px',
                }}
              >
                Partener RevMy.ro
              </span>
            </div>
            {NAV_LINKS.map((link) => (
              <Link
                key={link.label}
                href={link.href}
                className="transition-colors duration-200"
                style={{ fontSize: '14px', fontWeight: 500, color: 'var(--aluminum-dim)', fontFamily: 'DM Sans, sans-serif', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--aluminum-dim)')}
              >
                {link.label}
              </Link>
            ))}
          </div>
          {/* Social + copyright */}
          <div className="flex items-center gap-5">
            {/* Instagram */}
            <a href="#" aria-label="Instagram" style={{ color: 'var(--aluminum-dim)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--aluminum-dim)')}>
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
              </svg>
            </a>
            {/* TikTok */}
            <a href="#" aria-label="TikTok" style={{ color: 'var(--aluminum-dim)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--aluminum-dim)')}>
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.84 4.84 0 0 1-1.01-.07z"/>
              </svg>
            </a>
            <span style={{ color: 'var(--aluminum-faint)', fontSize: '13px', fontFamily: 'DM Sans, sans-serif' }}>
              © 2026 Asa Detailing
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}